<template>
  <div
    :class="['list_one', 'icon-combination-wrapper', 'list-one-style-'+listArr.module_style]"
    :key="i"
    :style="{
    width:type === 'ordinary' ? 100 / infor.col_num[infor.col_num.radio_val].value + '%' : '100%'
    }"
    data-comb-dom
    :data-col_num="infor.col_num[infor.col_num.radio_val].value"
    @mouseenter="module_isHover(true)"
    @mouseleave="module_isHover(false)"
  >
    <div
      :class="['module-content','module-content-style-'+listArr.module_style]"
      :style="{
        ...backgroundStyle,
        ...paddingStyle,
        ...box_shadow,
        borderRadius: pc_infor.borderRadius[pc_infor.borderRadius.radio_val].value + 'px'
      }">
      <!--  pc_infor.shadowVisible==='true'?'module-content-shadow':'', -->
      <div
        :class="['list_img_frame', 'animationBox', 'icon-combination-box', `icon-combination-${listArr.iconAlign}`]"
        ref="animationBox"
        @mouseenter="(e) => { templet.enter_animation(this.img_effects, e.target, this.$store.state.app.view_pattern) }"
        @mouseleave="(e) => { templet.leave_animation(this.img_effects, e.target) }"
      >
        <div class="icon-wrapper"
             :style="{width:infor.img_size[infor.img_size.radio_val].widthPercent+'%'}">
          <img class="img-icon" :src="item.img_path" :alt="item.title">
          <div
            class="tooptipPart img-tooltip"
            v-if="$store.state.app.view_pattern === 'pc' && item.img_type == 'custom'"
            @click.stop
          >
            <my_hover_btn :tips="$t('widgets_basic_icon_combination_components_one_icon_591')" btnIcon="el-icon-edit" @changeStyle="edit_one"></my_hover_btn>
          </div>
        </div>
        <div class="text-wrapper" :style="{...textWrapperStyle}">
          <div class="icon-combination-title" :style="{...titleFontStyle}">{{ item.title }}</div>
          <div class="icon-combination-summary" v-if="infor.alt_display==='true'" :style="{...summaryFontStyle}" v-html="item.summary.replace(/\n/g,'<br>')">
          </div>
        </div>
        <set_link class="linkPart" :sendData="item.intro"></set_link>
        <div
          class="tooptipPart one-icon-tooptip"
          v-if="$store.state.app.view_pattern === 'pc' && item.img_type == 'custom'"
          @click.stop
        >
          <my_edit_btn :module="module" tabName="style" coverClick @click.native="onClickEditBtn"></my_edit_btn>
          <my_hover_btn :tips="$t('widgets_basic_icon_combination_components_circle_layout_588')" btnIcon="el-icon-close" @changeStyle="del_one"></my_hover_btn>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import i18n from '../../../language/index'

import {getBoxShadowStyle} from '@/utils/utils'
export default {
  name: "basic_icon_combination_one_icon",
  data() {
    return {
      isHover: false
    };
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    pc_infor: {
      type: Object,
      default: null
    },
    item: {
      type: Object,
      default: null
    },
    i: {
      type: Number,
      default: 0
    },
    infor: {
      type: Object,
      default: null
    },
    type: {
      type: String,
      default: "ordinary"
    },
    imgs: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },
  methods: {
    module_isHover (val) {
      this.isHover = val
    },
    onClickEditBtn() {
      this.$store.commit("app/changeModuleSelectItemId", this.item.album_id);
      this.templet.changeStyle(this.module, 'style');
    },
    edit_one() {
      this.$store.commit("image_upload/set_fileType", 1);
      this.$store.commit("image_upload/set_showTag", true);
      this.$store.commit("image_upload/set_fileLimit", 1);
      this.$store.state.image_upload.imgFile = e => {
        if (e && e instanceof Array && e.length > 0) {
          this.item.img_path = e[0].filePath;
        }

        this.$store.state.image_upload.imgFile = null;
      };
    },
    del_one() {
      if (this.imgs.length <= 1) {
        this.$message.error({
          showClose: true,
          message: i18n.t('widgets_basic_icon_combination_components_circle_layout_589')
        });
        return;
      }
      this.$confirm(i18n.t('widgets_basic_icon_combination_components_circle_layout_590'), "", {
        confirmButtonText: i18n.t('view_public_topbar_24'),
        cancelButtonText: i18n.t('view_public_topbar_11'),
        center: true,
        // customClass: "del_dialog",
        appendToBody: true
      })
        .then(() => {
          this.imgs.splice(this.i, 1);
        })
        .catch(() => {
        });
    }
  },
  computed: {
    img_effects() {
      return this.module.data.img_effects;
    },
    listArr() {
      return this.module.data.listArr
    },
    titleFontStyle() {
      let style = this.$utils.getFontStyle(this.pc_infor.titleFont, this)
      // 添加悬浮变色逻辑
      if (this.isHover) {
        const titleFont = this.pc_infor.titleFont
        const radio_val = titleFont.radio_val
        if (radio_val === 'default' || radio_val === 'custom') {
          const selectColor = titleFont[radio_val].selectColor
          if (selectColor) {
            style.color = selectColor
          }
        }
      }
      return style
    },
    summaryFontStyle() {
      let style = this.$utils.getFontStyle(this.pc_infor.summaryFont, this)
      // 添加悬浮变色逻辑
      if (this.isHover) {
        const summaryFont = this.pc_infor.summaryFont
        const radio_val = summaryFont.radio_val
        if (radio_val === 'default' || radio_val === 'custom') {
          const selectColor = summaryFont[radio_val].selectColor
          if (selectColor) {
            style.color = selectColor
          }
        }
      }
      return style
    },
    backgroundStyle() {
      let style = this.$utils.getBackgroundStyle(this.pc_infor)
      // 添加悬浮变色逻辑
      if (this.isHover) {
        const set_style = this.pc_infor.set_style.background
        const radio_val = set_style.radio_val
        if (radio_val === 'default' || radio_val === 'custom') {
          const seColor = set_style[radio_val].seColor
          if (seColor) {
            style.backgroundColor = seColor
          }
        }
      }
      return style
    },
    paddingStyle() {
      let info = this.pc_infor.padding
      if (info.radio_val !== 'default') {
        let paddingTop = info.custom.paddingTop
        let paddingLeft = info.custom.paddingLeft
        if (!String(paddingTop).endsWith('%') && !String(paddingTop).endsWith('px')) {
          paddingTop = paddingTop + '%'
        }
        if (!String(paddingLeft).endsWith('%') && !String(paddingLeft).endsWith('px')) {
          paddingLeft = paddingLeft + '%'
        }
        return {
          padding: paddingTop + ' ' + paddingLeft
        }
      } else {
        return {
          padding: info.default.paddingTop + ' ' + info.default.paddingLeft
        }
      }
    },
    textWrapperStyle() {
      let style = {}
      if (Number(this.listArr.module_style) === 1) {
        let infor = this.infor
        style.width = (100 - infor.img_size[infor.img_size.radio_val].widthPercent) + '%'
      }
      return style
    },
    box_shadow(){ // 阴影设置 只有PC端才能有阴影 其他的不存在
      // return this.$store.state.app.view_pattern === 'pc' ?(this.isHover ? getBoxShadowStyle(this.pc_infor.boxShadow, 'hover') :getBoxShadowStyle(this.pc_infor.boxShadow)):{}
      return this.isHover ? getBoxShadowStyle(this.pc_infor.boxShadow, 'hover'):getBoxShadowStyle(this.pc_infor.boxShadow)
    },
  },
  components: {},
  created() {
  },
  mounted() {
    this.templet.initImageAnimation(
      this.img_effects,
      this.img_effects,
      this.$refs.animationBox,
      this.$store.state.app.view_pattern
    );
  }
};
</script>

<style scoped lang="scss">
.basic-icon-combination {

  .list_frame {
    .list_box {
      .list_one {
        position: relative;

        .tooptipPart {
          right: 0;
          bottom: 0;
          top: auto;
          display: none;
          z-index: 999;
        }

        .list_img_frame {
          position: relative;
          overflow: hidden;

          .list_img_back {
            width: 60px;
            height: 60px;
            position: absolute;
            left: 0;
            right: 0;
            margin-left: auto;
            margin-right: auto;
            background-position: center center;
            -webkit-transition: all ease 0.36s;
            -o-transition: all ease 0.36s;
            -moz-transition: all ease 0.36s;
            transition: all ease 0.36s;
            background-repeat: no-repeat;
          }
        }
      }

      .list_one:hover .tooptipPart {
        display: block;
      }
    }
  }
}

.icon-combination-wrapper {
  padding-left: 1%;
  padding-right: 1%;
  margin-top: 1%;
  margin-bottom: 1%;
}

.module-content {
  height: 100%;
  padding: 15%;
  transition: background-color 0.3s ease;
}

.module-content-shadow {
  //box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.20);
}


.icon-wrapper {
  display: inline-block;
  width: 25%;
  margin: 0 auto;
  position: relative;
}

.img-icon {
  max-width: 100%;
}

.icon-combination-title {
  font-size: 16px;
  color: #333;
  margin-top: 30px;
  line-height: 1.3;
  word-break:normal;
  transition: color 0.3s ease;
}

.icon-combination-summary {
  font-size: 14px;
  color: #999;
  margin-top: 12px;
  line-height: 1.4;
  word-break:normal;
  transition: color 0.3s ease;
}

.one-icon-tooptip {
  position: absolute;
  bottom: 10px;
  right: 10px;
}

.img-tooltip {
  top: 0 !important;
  display: none !important;
}

.icon-wrapper:hover {
  .img-tooltip {
    display: block !important;
  }
}


.module-content-style-0 {

  .icon-combination-default {
    text-align: center;
  }

  .icon-combination-center {
    text-align: center;
  }

  .icon-combination-left {
    text-align: left;
  }

  .icon-combination-right {
    text-align: right;
  }
}

.module-content-style-1 {
  display: flex;
}

.module-content-style-1 .icon-combination-box {
  display: flex;
  align-items: center;
}

.module-content-style-1 .icon-wrapper {
  text-align: center;
  flex: 1 1;
}

.module-content-style-1 {
  .text-wrapper {
    width: 75%;
    padding-left: 15px;
    text-align: left;
  }

  .icon-combination-top {
    align-items: flex-start;

    .icon-combination-title {
      margin-top: -0.2em;
    }
  }

  .icon-combination-bottom {
    align-items: flex-end;

    .icon-combination-summary {
      margin-bottom: -0.2em;
    }
  }
}


.module-content-style-1 .icon-combination-title {
  margin-top: 0;
}

.module-content-style-2 {
  background: #f2f2f2;

  .icon-wrapper {
    display: inline-block;
  }
}


.module-content-style-2 {
  padding: 12.5% 15.6%;

  .icon-combination-title {
    margin-top: 24px;
  }

  .icon-combination-summary {
    margin-top: 10px;
  }

  .icon-combination-default {
    text-align: left;
  }

  .icon-combination-left {
    text-align: left;
  }

  .icon-combination-center {
    text-align: center;
  }

  .icon-combination-right {
    text-align: right;
  }
}

// 圆环
.module-content-style-3 {
  .list_one {
    position: absolute !important;
  }

  .icon-combination-default {
    text-align: center;
  }

  .icon-combination-left {
    text-align: left;
  }

  .icon-combination-center {
    text-align: center;
  }

  .icon-combination-right {
    text-align: right;
  }
}

</style>



// WEBPACK FOOTER //
// src/widgets/basic_icon_combination/components/one_icon.vue